export default __webpack_public_path__ + "images/Goal.v-258fc2a43edfd28ab8e42d5e755f5544.png";